/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { controlsContainerStyles } from "@insite/content-library/Widgets/ProductList/ProductListControlsContainer";
import { screen } from "@monsma/XDL/Helpers";
import { ellipsis } from "@monsma/XDL/Utilities";
import { css } from "styled-components";

(controlsContainerStyles as any).paginationGridItem = {
    width: [12, 8, 8, 8, 8],
    css: css`
        > div > div {
            width: 100%;

            ${screen("lte", "md")} {
                > span {
                    margin-right: 15px !important;

                    > div {
                        > div {
                            margin-right: 0;
                        }
                    }
                }

                > nav {
                    max-width: 47%;

                    ul {
                        li {
                            &:nth-child(2) {
                                > div {
                                    margin: 0 7px;

                                    > span {
                                        max-width: 70%;
                                        ${ellipsis(1, 22)};
                                    }
                                }
                            }
                        }
                    }
                }
            }

            ${screen("lt", "sm")} {
                > span {
                    margin-right: 0 !important;
                }

                > nav {
                    max-width: 100%;

                    ul {
                        li {
                            &:nth-child(2) {
                                > div {
                                    > span {
                                        max-width: 81%;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            ${screen("gt", "567")} {
                justify-content: flex-end !important;
            }

            ${screen("gte", "sm")} {
                padding-left: 15px !important;
            }
        }
    `,
};

controlsContainerStyles.sortGridItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        &&& {
            ${screen("lt", "sm")} {
                margin-bottom: 15px;
            }
        }
    `,
};
